import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';

export const Header = styled(Flex)`
  justify-content: space-between;

  ${({ theme }) => css`
    color: ${theme.colors.primaryBlue};
    margin-bottom: ${theme.spacing(3)};
    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(4)};
    }
  `}
`;

export const TitleMobile = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h2Mobile};
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    line-height: 1;

    ${theme.media.md.up} {
      display: none;
    }
  `}
`;

export const TitleDesktop = styled(Box)`
  display: none;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      display: unset;
    }
  `}
`;
